import VerifyModal from './VerifyModal'

export default VerifyModal
